import {useState, useEffect} from "react";

import * as api from "../../../services/api";
const {useFeedbackTools} = require("../../../components/FeedbackTools");


const useGoogleAccount = () => {
    const [state, setState] = useState({googleAccount: null, isLoading: true});
    const {showErrorNotification} = useFeedbackTools();

    // Load the account when mounted
    useEffect(
        () => {
            const load = async () => {
                try{
                    const googleAccount = await api.GoogleAccount.getGoogleAccount();
                    setState({googleAccount: googleAccount, isLoading: false});
                }catch(e){
                    showErrorNotification(e);
                }
            }
            load();
        },
        []  // eslint-disable-line react-hooks/exhaustive-deps
    )

    // Create the new Google account
    const createGoogleAccount = async (data) => {
        const googleAccount = await api.GoogleAccount.createGoogleAccount(data);
        setState({
            googleAccount: googleAccount,
            isLoading: false
        });
    }

    return {
        googleAccount: state.googleAccount,
        isLoading: state.isLoading,
        createGoogleAccount,
    }
}

export default useGoogleAccount;